<script>
import { marked } from 'marked';
import { getCustomRender } from './marked';
import { debounce } from 'lodash';

export default {
  name: 'Markdown',
  props: {
    source: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      html: '',
    };
  },
  created() {
    const renderer = getCustomRender();
    const updateHTML = () => {
      try {
        this.html = marked.parse(String(this.source || ''), { renderer });
      } catch (e) {
        console.error('[markdown] parse error', this, e);
      }
    };
    this.$watch(
      'source',
      debounce(updateHTML, 200, { leading: true, trailing: true }),
      { immediate: true },
    );
  },
  render() {
    return this.$createElement('div', {
      class: 'markdown-body xy-markdown',
      domProps: {
        innerHTML: this.html,
      },
    });
  },
};
</script>

<style>
.xy-markdown .code-enhance .code-enhance-codeblock {
  padding: 0;
  background: #f9f9f9;
}
</style>
